"use client";

import { useEffect } from "react";
import { registerPartnerAttribution } from "@/lib/partner/analytics";

// Renders nothing. Registers the roave_partner cookie (if any) as a
// PostHog super-property and a GTM dataLayer value, once per session. A
// no-op on www.letsroave.com, where the cookie is never set.
export default function PartnerAttribution() {
  useEffect(() => {
    registerPartnerAttribution();
  }, []);

  return null;
}
